var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-container myswiper"},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("swipper-item")],2),_c('div',{staticClass:"swiper-pagination"})])
}
var staticRenderFns = []

export { render, staticRenderFns }